// extracted by mini-css-extract-plugin
export default {"select":"Select_select__DIDVl","countrySelect":"Select_countrySelect__GGx-R"};